import { useEffect, useState } from "react";
import { Show } from "@clerk/react";
import { Navigate } from "react-router-dom";
import { Trophy, Crown, Medal } from "lucide-react";
import Nav from "@/components/Nav";
import { publicApi } from "@/lib/api";

export default function Leaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { publicApi.get("/leaderboard?limit=50").then((r) => setRows(r.data)); }, []);

  const icon = (i) => {
    if (i === 0) return <Crown size={22} strokeWidth={2.5} className="text-[var(--tp-accent)]" />;
    if (i === 1) return <Medal size={22} strokeWidth={2.5} className="text-slate-400" />;
    if (i === 2) return <Medal size={22} strokeWidth={2.5} className="text-amber-700" />;
    return <span className="font-black text-slate-500 w-6 text-center">{i + 1}</span>;
  };

  return (
    <>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
      <Show when="signed-in">
        <Nav />
        <main className="max-w-3xl mx-auto px-4 py-10">
          <div className="flex items-center gap-3 mb-6">
            <Trophy size={32} strokeWidth={2.5} className="text-[var(--tp-accent)]" />
            <h1 className="text-4xl font-black tracking-tight">Leaderboard</h1>
          </div>
          <div className="sticker overflow-hidden" data-testid="leaderboard-list">
            {rows.length === 0 && <p className="p-6 text-slate-500">No scores yet. Be the first to play!</p>}
            {rows.map((r, i) => (
              <div key={r.id} className={`flex items-center gap-4 px-5 py-3 ${i !== rows.length - 1 ? "border-b-[2px] border-slate-200" : ""}`}>
                <div className="w-8 flex justify-center">{icon(i)}</div>
                <div className="flex-1 min-w-0">
                  <p className="font-black truncate">{r.user_name || "Player"}</p>
                  <p className="text-sm text-slate-500 truncate">{r.quiz_title}</p>
                </div>
                <div className="text-right">
                  <p className="font-black text-[var(--tp-success)]">{r.score} / {r.total}</p>
                </div>
              </div>
            ))}
          </div>
        </main>
      </Show>
    </>
  );
}
